import './App.scss'
import { SnackbarProvider } from '@ucl/react-library/snackbar'
import { lazy } from 'react'
import { MarginWrapper } from '@components/StyledComponents'
import { AEMPage } from '@ucl/aem-library/aemPage'
import { EditableTabs } from '@ucl/aem-library/tabs'
import { EditableText } from '@ucl/aem-library/richTextEditor'
import { AEMPagePath, getAEMHost } from '@utils/aem'
import { AccountProvider } from '@src/AccountContext'
import ErrorFallback from '@components/error-handling/ErrorFallback'

const AccountSettingsTabLazy = lazy(() => import('@components/tabs/AccountSettingsTab'))
const TermsAndConditionsTabLazy = lazy(() => import('@components/tabs/TermsAndConditionsTab'))

const App = () => {
  return (
    <AEMPage
      pagePath={AEMPagePath.CUSTOMER_PROFILE}
      aemHost={getAEMHost()}
      fallback={(props) => <ErrorFallback {...props} />}
    >
      <AccountProvider>
        <SnackbarProvider>
          <MarginWrapper margin="24px 0 96px 0">
            <MarginWrapper margin={'8px 0 16px 0'}>
              <EditableText name={'settings-header'} />
            </MarginWrapper>
            <EditableTabs
              name={'settings-tabs'}
              tabContent={[<AccountSettingsTabLazy />, <TermsAndConditionsTabLazy />]}
            />
          </MarginWrapper>
        </SnackbarProvider>
      </AccountProvider>
    </AEMPage>
  )
}

export default App
